export default __webpack_public_path__ + "static/media/Hood of the Doomsayer.c9350d6b.jpg";